import React, {useEffect, useState} from "react"
import {apiGet} from "../../../Api/index";
import {Row, Col, Div, Text} from "atomize";
import theme from "../../../Theme/Theme";
import styled from "styled-components";
import Bundles from "../../Molecules/Bundles/index";


const Wrapper = styled(Row)`
  // border: 1px solid ${theme.colors.primary};
  // padding: 3rem 2rem;
  margin-top: 6rem;
  justify-content: space-between;
  position: relative;
  // background: white;
  
`;

const Intro = styled.div`
  p {
    color: ${theme.colors.grayDark};
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
  }
  
  @media only screen and (max-width: 766px) {
    margin-bottom: 1rem;
  }
`;

const Title = styled(Text)`
  min-height: 36px;	
  margin: 0 0 1rem 0 !important;
  color: ${theme.colors.dark};	
  font-family: Inter;	
  font-size: 24px;	
  font-weight: bold;	
  line-height: 36px;
`;

const Body = styled(Col)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

function ActivityBundles(props) {
  const [data, setData] = useState(null);
  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/paragraph/activity_bundles/${props.id}?include=field_activity_bundles&jsonapi_include=1`);
      setData(result.data.data);
    }
    fetchData();
  }, []);

  return (
    <Wrapper>
      {
        data &&
        <>
          <Body
            size={{ xs: '12', lg: '10' }}
          >
          <Title
            tag="h3"
          >
            Activity Bundles
          </Title>
          <Intro
            dangerouslySetInnerHTML={ { __html: data.field_description.value} }
          />
          </Body>
          <Col
            size={{ xs: '12' }}
          >
            <Bundles
              bundles={data.field_activity_bundles}
              view={props.view}
            />
          </Col>
        </>
      }
    </Wrapper>
  )
}



export default ActivityBundles
